import { render } from "./SingleReturnItem.vue?vue&type=template&id=4b749491"
import script from "./SingleReturnItem.vue?vue&type=script&lang=js"
export * from "./SingleReturnItem.vue?vue&type=script&lang=js"

import exportComponent from "/usr/local/var/www/duo_front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__